export const generateDiscountArray = () => {
    const discountArray = [-100, -75, -70, -65, -60, -55, -50, -45, -40, -35, -30, -25, -20];
    
    for (let discount = -15; discount <= 15; discount++) {
      discountArray.push(discount);
    }
  
    discountArray.push(20);
    discountArray.push(25);
  
    return discountArray;
  };